import { render } from "./Vocabularies.vue?vue&type=template&id=5b133f55"
import script from "./Vocabularies.vue?vue&type=script&lang=js"
export * from "./Vocabularies.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__